<template>
  <div class="activiti"
  >
    <div :class="{
        'activiti__list': !fullList,
        'activiti__list_full': fullList
      }"
    >
        <BaseBtn
          v-for="(item, indexItem) in TagsDataFilter"
          :key="indexItem"
          :text="item?.Name"
          white
          :active="item.IsActive"
          @clickBtn="activeTag(item.Id, indexItem, item)"
        />
      <div class="activiti__block-adder">
        <BlockAdder
          @click="goToAdd()"
        >
        </BlockAdder>
      </div>
    </div>
    <div class="activiti__show-button">
      <BaseBtn
        blue
        :text="!fullList ? 'Все теги' : 'Скрыть теги'"
        @click="getFullList"
      />
    </div>
  </div>
  <AddTagsModal
    v-if="AddtagsModalVisible"
    :categoryId="activitiesId"
    :dropdownActive="false"
    tagsEducation
  />
</template>

<script>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

import BaseBtn from '@/components/ui/BaseBtn.vue'
import BlockAdder from '@/components/elements/BlockAdder.vue'
import AddTagsModal from '@/components/modals/AddTagsModal.vue'

export default {
  name: 'TagsModalActivitiesEducation',
  components: {
    BaseBtn,
    BlockAdder,
    AddTagsModal
  },
  props: {
  },
  setup () {
    const store = useStore()

    const fullList = ref(false)

    const TagsDataFilter = computed(() => {
      return store.getters.getTagsDataFilter
    })

    const AddtagsModalVisible = computed(() => {
      return store.getters.getShowAddTagsEditor
    })

    const activeTag = (id, indexItem, item) => {
      store.commit('SetChangeTagsObj', item)

      store.commit('SetSelectedTagsEducation', {
        id: id,
        indexItem: indexItem
      })

      store.dispatch('setCheckInnerTagEducation', item)
    }

    const goToAdd = () => {
      store.commit('SetShowAddTagsEditor', true)
    }

    const getFullList = () => {
      fullList.value = !fullList.value
    }

    return {
      goToAdd,
      AddtagsModalVisible,
      TagsDataFilter,
      getFullList,
      activeTag,
      fullList
    }
  }
}
</script>

<style lang="scss" scoped>
.activiti {
  margin-bottom: 30px;

  &__title {
    font-weight: 500;
    font-size: 20px;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: start;
  }

  &__list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    max-height: 175px;
    overflow: hidden;
    margin-bottom: 16px;
    padding: 16px 0;

    &_full {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
      margin-bottom: 16px;
      padding: 16px 0;
    }
  }

  &__show-button {
    display: flex;
    justify-content: space-around;
  }
}

::v-deep
  .base-button  {
    height: 38px;
  }
</style>
